import { render } from "./KafedraVsShaxsiyReja.vue?vue&type=template&id=4ba1adaa&scoped=true"
import script from "./KafedraVsShaxsiyReja.vue?vue&type=script&lang=js"
export * from "./KafedraVsShaxsiyReja.vue?vue&type=script&lang=js"

import "./KafedraVsShaxsiyReja.vue?vue&type=style&index=0&id=4ba1adaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba1adaa"]])

export default __exports__